// @generated
// THIS FILE WAS AUTOMATICALLY GENERATED AND SHOULD NOT BE EDITED
/* eslint-disable */
import type * as Types from '../../../__generated-gql-types__/globalTypes';

import { gql } from '@apollo/client';
import { BaseAllReviewsModalReviewFragmentDoc } from '../../coach/modals/__generated-gql-types__/BaseAllReviewsModal.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AllPackageReviewsModalReviewFragment = {
  __typename?: 'Review';
  id: string;
  anonymous: boolean;
  rate: number;
  overallRate: number;
  headline?: string | null;
  comment?: string | null;
  guestReviewer?: string | null;
  reviewedAt: number;
  applicant?: {
    __typename?: 'Applicant';
    id: string;
    user: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      pictureLink?: string | null;
      email: string;
    };
  } | null;
  coach: {
    __typename?: 'Coach';
    id: string;
    slug: string;
    user: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      pictureLink?: string | null;
      email: string;
    };
  };
  categoryReviews?: Array<{
    __typename?: 'CategoryReview';
    responsiveness?: number | null;
    supportiveness?: number | null;
    knowledge?: number | null;
    value?: number | null;
    category: {
      __typename?: 'Category';
      id: string;
      name: string;
      slug: string;
      isFeatured: boolean;
      goal: Types.GoalName;
      coachingFocusList?: Array<{
        __typename?: 'CoachingFocus';
        id: string;
        name: string;
      }> | null;
    };
    subCategoryList?: Array<{
      __typename?: 'SubCategory';
      name: string;
    }> | null;
  }> | null;
  outcomes?: Array<
    | {
        __typename?: 'JobOfferInfo';
        company: {
          __typename?: 'Company';
          id?: string | null;
          name: string;
          logoLink?: string | null;
        };
      }
    | {
        __typename?: 'SchoolAdmissionInfo';
        status?: Types.SchoolAdmissionStatus | null;
        school: {
          __typename?: 'School';
          id: string;
          name: string;
          logoLink?: string | null;
        };
      }
    | { __typename?: 'TestScoreV2'; score: number; testName: string }
  > | null;
  mostRecentOrder?: {
    __typename?: 'Order';
    id: string;
    classOrder?: {
      __typename?: 'ClassOrder';
      coachingSession: {
        __typename?: 'CoachingSession';
        id: string;
        content:
          | { __typename?: 'BootcampSession' }
          | { __typename?: 'Class'; id: string; name?: string | null }
          | { __typename?: 'OneOnOneSession' };
      };
    } | null;
    packageOrder?: {
      __typename?: 'OfferingPackage';
      id: string;
      name: string;
      visibility: Types.PackageVisibility;
      category?: { __typename?: 'Category'; id: string; name: string } | null;
    } | null;
  } | null;
  mostRecentClassSession?: {
    __typename?: 'CoachingSession';
    id: string;
    content:
      | { __typename?: 'BootcampSession' }
      | {
          __typename?: 'Class';
          id: string;
          name?: string | null;
          isFreeEvent?: boolean | null;
        }
      | { __typename?: 'OneOnOneSession' };
  } | null;
};

export type AllPackageReviewsModalReviewsForPackageQueryVariables =
  Types.Exact<{
    categoryUrn: Types.Scalars['CategoryUrn']['input'];
    start: Types.Scalars['Int']['input'];
    count: Types.Scalars['Int']['input'];
  }>;

export type AllPackageReviewsModalReviewsForPackageQuery = {
  __typename?: 'Query';
  reviewsForPackage: {
    __typename?: 'ReviewBatchResponse';
    total: number;
    results: Array<{
      __typename?: 'Review';
      id: string;
      anonymous: boolean;
      rate: number;
      overallRate: number;
      headline?: string | null;
      comment?: string | null;
      guestReviewer?: string | null;
      reviewedAt: number;
      applicant?: {
        __typename?: 'Applicant';
        id: string;
        user: {
          __typename?: 'User';
          id: string;
          firstName: string;
          lastName: string;
          pictureLink?: string | null;
          email: string;
        };
      } | null;
      coach: {
        __typename?: 'Coach';
        id: string;
        slug: string;
        user: {
          __typename?: 'User';
          id: string;
          firstName: string;
          lastName: string;
          pictureLink?: string | null;
          email: string;
        };
      };
      categoryReviews?: Array<{
        __typename?: 'CategoryReview';
        responsiveness?: number | null;
        supportiveness?: number | null;
        knowledge?: number | null;
        value?: number | null;
        category: {
          __typename?: 'Category';
          id: string;
          name: string;
          slug: string;
          isFeatured: boolean;
          goal: Types.GoalName;
          coachingFocusList?: Array<{
            __typename?: 'CoachingFocus';
            id: string;
            name: string;
          }> | null;
        };
        subCategoryList?: Array<{
          __typename?: 'SubCategory';
          name: string;
        }> | null;
      }> | null;
      outcomes?: Array<
        | {
            __typename?: 'JobOfferInfo';
            company: {
              __typename?: 'Company';
              id?: string | null;
              name: string;
              logoLink?: string | null;
            };
          }
        | {
            __typename?: 'SchoolAdmissionInfo';
            status?: Types.SchoolAdmissionStatus | null;
            school: {
              __typename?: 'School';
              id: string;
              name: string;
              logoLink?: string | null;
            };
          }
        | { __typename?: 'TestScoreV2'; score: number; testName: string }
      > | null;
      mostRecentOrder?: {
        __typename?: 'Order';
        id: string;
        classOrder?: {
          __typename?: 'ClassOrder';
          coachingSession: {
            __typename?: 'CoachingSession';
            id: string;
            content:
              | { __typename?: 'BootcampSession' }
              | { __typename?: 'Class'; id: string; name?: string | null }
              | { __typename?: 'OneOnOneSession' };
          };
        } | null;
        packageOrder?: {
          __typename?: 'OfferingPackage';
          id: string;
          name: string;
          visibility: Types.PackageVisibility;
          category?: {
            __typename?: 'Category';
            id: string;
            name: string;
          } | null;
        } | null;
      } | null;
      mostRecentClassSession?: {
        __typename?: 'CoachingSession';
        id: string;
        content:
          | { __typename?: 'BootcampSession' }
          | {
              __typename?: 'Class';
              id: string;
              name?: string | null;
              isFreeEvent?: boolean | null;
            }
          | { __typename?: 'OneOnOneSession' };
      } | null;
    }>;
  };
};

export const AllPackageReviewsModalReviewFragmentDoc = gql`
  fragment AllPackageReviewsModal_Review on Review {
    id
    ...BaseAllReviewsModal_Review
  }
  ${BaseAllReviewsModalReviewFragmentDoc}
`;
export const AllPackageReviewsModalReviewsForPackageDocument = gql`
  query AllPackageReviewsModal_ReviewsForPackage(
    $categoryUrn: CategoryUrn!
    $start: Int!
    $count: Int!
  ) {
    reviewsForPackage(categoryUrn: $categoryUrn, start: $start, count: $count) {
      results {
        ...AllPackageReviewsModal_Review
      }
      total
    }
  }
  ${AllPackageReviewsModalReviewFragmentDoc}
`;

/**
 * __useAllPackageReviewsModalReviewsForPackageQuery__
 *
 * To run a query within a React component, call `useAllPackageReviewsModalReviewsForPackageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPackageReviewsModalReviewsForPackageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPackageReviewsModalReviewsForPackageQuery({
 *   variables: {
 *      categoryUrn: // value for 'categoryUrn'
 *      start: // value for 'start'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useAllPackageReviewsModalReviewsForPackageQuery(
  baseOptions: Apollo.QueryHookOptions<
    AllPackageReviewsModalReviewsForPackageQuery,
    AllPackageReviewsModalReviewsForPackageQueryVariables
  > &
    (
      | {
          variables: AllPackageReviewsModalReviewsForPackageQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AllPackageReviewsModalReviewsForPackageQuery,
    AllPackageReviewsModalReviewsForPackageQueryVariables
  >(AllPackageReviewsModalReviewsForPackageDocument, options);
}
export function useAllPackageReviewsModalReviewsForPackageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AllPackageReviewsModalReviewsForPackageQuery,
    AllPackageReviewsModalReviewsForPackageQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AllPackageReviewsModalReviewsForPackageQuery,
    AllPackageReviewsModalReviewsForPackageQueryVariables
  >(AllPackageReviewsModalReviewsForPackageDocument, options);
}
export function useAllPackageReviewsModalReviewsForPackageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AllPackageReviewsModalReviewsForPackageQuery,
        AllPackageReviewsModalReviewsForPackageQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AllPackageReviewsModalReviewsForPackageQuery,
    AllPackageReviewsModalReviewsForPackageQueryVariables
  >(AllPackageReviewsModalReviewsForPackageDocument, options);
}
export type AllPackageReviewsModalReviewsForPackageQueryHookResult = ReturnType<
  typeof useAllPackageReviewsModalReviewsForPackageQuery
>;
export type AllPackageReviewsModalReviewsForPackageLazyQueryHookResult =
  ReturnType<typeof useAllPackageReviewsModalReviewsForPackageLazyQuery>;
export type AllPackageReviewsModalReviewsForPackageSuspenseQueryHookResult =
  ReturnType<typeof useAllPackageReviewsModalReviewsForPackageSuspenseQuery>;
export type AllPackageReviewsModalReviewsForPackageQueryResult =
  Apollo.QueryResult<
    AllPackageReviewsModalReviewsForPackageQuery,
    AllPackageReviewsModalReviewsForPackageQueryVariables
  >;
